import { useState, useEffect } from 'react';

const parseStoredFlag = (rawValue, defaultValue) => {
  if (rawValue === null || rawValue === undefined) {
    return defaultValue;
  }
  const trimmed = rawValue.trim().toLowerCase();
  if (trimmed === '1' || trimmed === 'true' || trimmed === 'yes' || trimmed === 'on') {
    return true;
  }
  if (trimmed === '0' || trimmed === 'false' || trimmed === 'no' || trimmed === 'off') {
    return false;
  }
  return defaultValue;
};

const readFlagFromStorage = (key, defaultValue) => {
  if (typeof window === 'undefined') {
    return defaultValue;
  }
  try {
    const raw = window.localStorage.getItem(key);
    return parseStoredFlag(raw, defaultValue);
  } catch {
    return defaultValue;
  }
};

const writeFlagToStorage = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(key, value ? '1' : '0');
  } catch {
    // ignore write errors (e.g., storage disabled)
  }
};

const useLocalStorageFlag = (key, defaultValue = false) => {
  const [flag, setFlag] = useState(() => readFlagFromStorage(key, defaultValue));

  useEffect(() => {
    writeFlagToStorage(key, flag);
  }, [key, flag]);

  return [flag, setFlag];
};

export default useLocalStorageFlag;
